<template>
  <md-list-item v-if="!completed">
    <md-icon>cloud_upload</md-icon>
    <span>{{area.name}}</span>
    <md-button v-if="!hasStarted" class="md-accent md-raised" @click="startArea">INICIAR UPLOAD</md-button>
    <md-list-expand>
      <md-list>
        <structure-sync-item @structureSynced="structureSyncHandler" v-for="(item,key) in area.structures" :key="item['.key']" :areaStarted="hasStarted" :id="key" :name="item.name" :photos="item.photos" :status="item.status" :areaId="area.id" :itemId="item.id" :type="item.type"></structure-sync-item>
      </md-list>
      <md-list>
        <structure-sync-item @structureSynced="verticeSyncHandler" v-for="(item,key) in area.vertices"  :key="item['.key']" :id="key" :areaStarted="hasStarted" :name="item.name" :photos="item.photos" :status="item.status" :areaId="area.id" :itemId="item.id.toString()" :type="item.type"></structure-sync-item>
      </md-list>
    </md-list-expand>
  </md-list-item>
</template>
<script>
import StructureSyncItem from '@/components/StructureSyncItem'
export default {
  name: 'area-sync-list',
  components: {
    'structure-sync-item': StructureSyncItem
  },
  props: {
    area: { type: Object, required: true }
  },
  data () {
    return {
      hasStarted: false,
      structureSynced: [],
      verticeSynced: [],
      completed: false
    }
  },
  watch: {
    structureSynced: function (newlist) {
      let structureCount = 0
      if (this.area.structures != null) {
        structureCount = this.area.structures.length
      }
      if (this.structureSynced.length === structureCount && this.verticeSynced.length === this.area.vertices.length) {
        this.completed = true
        this.$emit('areaSynced', this.area.id)
      }
    },
    verticeSynced: function (newList) {
      let structureCount = 0
      if (this.area.structures != null) {
        structureCount = this.area.structures.length
      }
      if (this.structureSynced.length === structureCount && this.verticeSynced.length === this.area.vertices.length) {
        this.completed = true
        this.$emit('areaSynced', this.area.id)
      }
    }
  },
  methods: {
    startArea() {
      this.hasStarted = true
    },
    structureSyncHandler (structureId) {
      if (!this.structureSynced.find(function (id) { return id === structureId })) {
        this.structureSynced.push(structureId)
      }
    },
    verticeSyncHandler (verticeId) {
      if (!this.verticeSynced.find(function (id) { return id === verticeId })) {
        this.verticeSynced.push(verticeId)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AreaSyncList.vue?27e87932